import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { Info } from '@liveauctioneers/hammer-ui-core/icons';
import React from 'react';
import Tooltip from '@liveauctioneers/caterwaul-components/lib/Tooltip/Tooltip';

const WhatIsCountdownPopover = () => (
    <Tooltip
        placement="left"
        trigger={
            <Info
                color="primary"
                size="sm"
                style="fill"
            />
        }
    >
        <FormattedMessage id="itemBidding.dontWait" />
    </Tooltip>
);

export default WhatIsCountdownPopover;
